/* Gifty evergreen spin wheel. */
(function () {
  'use strict';

  var root = document.getElementById('g99');
  var cfgEl = document.getElementById('gifty99-config');
  if (!root || !cfgEl) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  /* ---------- state ---------- */
  var STORE_KEY = 'gifty99';
  function readState() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}'); } catch (e) { return {}; }
  }
  function writeState(patch) {
    var s = readState();
    for (var k in patch) { if (patch.hasOwnProperty(k)) s[k] = patch[k]; }
    try { localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) {}
    return s;
  }

  /* ---------- analytics ---------- */
  function deviceClass() {
    var w = window.innerWidth;
    return w < 760 ? 'mobile' : (w < 990 ? 'tablet' : 'desktop');
  }
  // gtag.js is loaded by a third-party app, not this theme, so its readiness
  // relative to auto-open is not guaranteed. Retry briefly rather than
  // silently drop the event (same pattern as assets/gifty-analytics.js).
  function track(name, tier, retriesLeft, eventParams) {
    var payload = { campaign: 'spinwheel-evergreen-v1', wheel_version: 'evergreen-v1', device_class: deviceClass() };
    if (tier !== null && tier !== undefined) payload.prize_tier = tier;
    if (eventParams) Object.assign(payload, eventParams);
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
      return;
    }
    retriesLeft = retriesLeft === undefined ? 12 : retriesLeft;
    if (retriesLeft <= 0) return;
    setTimeout(function () { track(name, tier, retriesLeft - 1, eventParams); }, 300);
  }

  /* ---------- helpers ---------- */
  // U+202F (narrow no-break space) after the peso sign: the Onest glyph's
  // crossbar otherwise collides with the next digit and reads as a strikethrough.
  function money(cents) {
    return '₱ ' + Math.round(cents / 100).toLocaleString('en-PH');
  }
  function setSlot(name, value) {
    var el = root.querySelector('[data-g99-slot="' + name + '"]');
    if (el) el.textContent = value;
  }
  function showState(name) {
    var nodes = root.querySelectorAll('[data-g99-state]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].hidden = nodes[i].getAttribute('data-g99-state') !== name;
    }
  }
  function updateLauncher() {
    var launcher = document.getElementById('g99-launcher');
    if (!launcher) return;
    var s = readState();
    var hasPrize = !!(s.spunAt && s.code);
    launcher.textContent = hasPrize ? '🎁 Your prize' : '🎁 Spin & win';
    launcher.setAttribute('aria-label', hasPrize ? 'Open your Gifty prize' : 'Open the Gifty spin wheel');
  }

  setSlot('headline', CFG.headline);
  setSlot('subline', CFG.subline);

  /* ---------- confetti ---------- */
  var confettiHost = document.getElementById('g99-confetti');
  function burstConfetti() {
    if (!confettiHost) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var colors = ['#FF66B2', '#FFCC66', '#ffffff', '#D81B60', '#FF9ED2'];
    var frag = document.createDocumentFragment();
    for (var i = 0; i < 34; i++) {
      var p = document.createElement('i');
      p.style.left = Math.random() * 100 + '%';
      p.style.background = colors[i % colors.length];
      p.style.animationDuration = (2.2 + Math.random() * 1.6) + 's';
      p.style.animationDelay = (Math.random() * 0.35) + 's';
      p.style.transform = 'translateY(-10px) rotate(' + (Math.random() * 360) + 'deg)';
      frag.appendChild(p);
    }
    confettiHost.innerHTML = '';
    confettiHost.appendChild(frag);
    setTimeout(function () { if (confettiHost) confettiHost.innerHTML = ''; }, 4200);
  }

  /* ---------- sound (Web Audio, synthesised, no asset) ---------- */
  var actx = null;
  var muted = false;
  try { muted = localStorage.getItem('gifty99muted') === '1'; } catch (e) {}
  function unlockAudio() {
    if (muted) return;
    try {
      if (!actx) actx = new (window.AudioContext || window.webkitAudioContext)();
      if (actx.state === 'suspended') actx.resume();
    } catch (e) { actx = null; }
  }
  function tick(when, freq, gainv, dur) {
    if (!actx) return;
    var o = actx.createOscillator(), g = actx.createGain();
    o.type = 'square'; o.frequency.value = freq;
    g.gain.setValueAtTime(0.0001, when);
    g.gain.exponentialRampToValueAtTime(gainv, when + 0.004);
    g.gain.exponentialRampToValueAtTime(0.0001, when + dur);
    o.connect(g); g.connect(actx.destination);
    o.start(when); o.stop(when + dur + 0.02);
  }
  function playSpinSound(ms) {
    if (muted || !actx) return;
    var t = actx.currentTime, total = ms / 1000;
    // ticks that fan out from ~45ms apart to ~320ms apart, mimicking the deceleration
    var elapsed = 0, gap = 0.045;
    while (elapsed < total - 0.15) {
      var p = elapsed / total;
      tick(t + elapsed, 1400 - p * 500, 0.05 * (1 - p * 0.5), 0.03);
      gap = 0.045 + p * p * 0.30;
      elapsed += gap;
    }
  }
  function playWinSound() {
    if (muted) return;
    unlockAudio();
    if (!actx) return;
    var t = actx.currentTime;
    var notes = [523.25, 659.25, 783.99, 1046.5]; // C5 E5 G5 C6
    notes.forEach(function (f, i) {
      var o = actx.createOscillator(), g = actx.createGain();
      o.type = 'triangle'; o.frequency.value = f;
      var when = t + i * 0.09;
      g.gain.setValueAtTime(0.0001, when);
      g.gain.exponentialRampToValueAtTime(0.16, when + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, when + 0.45);
      o.connect(g); g.connect(actx.destination);
      o.start(when); o.stop(when + 0.5);
    });
  }
  function setMuted(v) {
    muted = v;
    try { localStorage.setItem('gifty99muted', v ? '1' : '0'); } catch (e) {}
    var b = document.getElementById('g99-mute');
    if (b) { b.setAttribute('aria-pressed', String(v)); b.textContent = v ? '🔇' : '🔊'; }
  }

  /* ---------- modal open / close ---------- */
  var lastFocus = null;
  var armed = true;
  var titleEl = root.querySelector('.g99__title');
  var sayEl = root.querySelector('.g99__say');
  var wonPrize = null;
  var focusOnOpen = false;

  function buildRevealFromState(s) {
    wonPrize = { amount: s.tier, code: s.code };
    setSlot('prize2', money(s.tier * 100) + ' OFF');
    setSlot('code', s.code);
    setSlot('revealfine', 'Saved on this device. One use per customer at checkout.');
    document.getElementById('g99-claim-link').href =
      '/discount/' + s.code + '?redirect=' + encodeURIComponent(CFG.pdpUrl);
    titleEl.textContent = 'Your Gifty prize';
    sayEl.textContent = '';
    showState('reveal');
    var link = document.getElementById('g99-claim-link');
    if (link && focusOnOpen) link.focus({ preventScroll: true });
  }

  var closeTimer = null;
  function openModal(trigger) {
    armed = false;
    window.removeEventListener('scroll', onAutoScroll);
    focusOnOpen = trigger === 'manual' || trigger === 'launcher';
    lastFocus = document.activeElement;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    root.hidden = false;
    // commit the closed state, then add .is-open so the CSS transition runs.
    // A forced reflow is more reliable than rAF (which is throttled in hidden tabs).
    void root.offsetWidth;
    root.style.opacity = '';
    root.classList.add('is-open');
    // safety net: if the transition never progresses (throttled tab, heavy load)
    // force the open state so the modal is never left invisible.
    setTimeout(function () {
      if (!root.hidden && root.classList.contains('is-open')) root.style.opacity = '1';
    }, 550);
    if (!readState().seenAt) writeState({ seenAt: Date.now() });
    var s = readState();
    if (s.spunAt && s.code && s.claimedAt) {
      buildRevealFromState(s);
    } else if (s.spunAt && s.code) {
      wonPrize = { amount: s.tier, code: s.code };
      showWin();
    } else {
      showState('intro');
      titleEl.textContent = CFG.headline;
      sayEl.textContent = CFG.subline;
      if (!readState().spunAt) {
        spinButtons.forEach(function (b) { if (b) b.disabled = false; });
      }
      var cta = document.getElementById('g99-spin-cta');
      if (cta && focusOnOpen) cta.focus({ preventScroll: true });
    }
    track('spin_wheel_shown', null, undefined, { trigger: trigger });
  }

  function closeModal() {
    writeState({ dismissedAt: Date.now() });
    if (!readState().spunAt) track('spin_wheel_dismissed', null);
    root.style.opacity = '';
    root.classList.remove('is-open');
    var delay = reduceMotion() ? 0 : 240;
    closeTimer = setTimeout(function () { root.hidden = true; }, delay);
    if (root.contains(document.activeElement) && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.hasAttribute && t.hasAttribute('data-g99-close')) {
      closeModal();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') { closeModal(); return; }
    // Non-modal promotion: Tab can leave the sheet and reach the page.
  });

  /* ---------- spin ---------- */
  function weightedPick(prizes) {
    var total = 0, i;
    for (i = 0; i < prizes.length; i++) total += prizes[i].weight;
    var r = Math.random() * total;
    for (i = 0; i < prizes.length; i++) {
      r -= prizes[i].weight;
      if (r <= 0) return prizes[i];
    }
    return prizes[prizes.length - 1];
  }
  function segmentAngleFor(amount) {
    var segs = CFG.segments, idxs = [], i;
    for (i = 0; i < segs.length; i++) if (segs[i] === amount) idxs.push(i);
    if (!idxs.length) idxs = [0];
    var chosen = idxs[Math.floor(Math.random() * idxs.length)];
    var per = 360 / segs.length;
    // wedges are centered on multiples of `per` (segmentCentered), so the wedge
    // centre angle is chosen*per; a tiny jitter keeps repeat wins from looking identical
    return chosen * per + (Math.random() * 0.5 - 0.25) * per;
  }

  var disc = document.getElementById('g99-disc');
  var spinButtons = [document.getElementById('g99-spin'), document.getElementById('g99-spin-cta')];
  var spinning = false;

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function doSpin() {
    if (spinning || readState().spunAt) return;
    spinning = true;
    spinButtons.forEach(function (b) { if (b) b.disabled = true; });
    wonPrize = weightedPick(CFG.prizes);
    writeState({ spunAt: Date.now(), tier: wonPrize.amount, code: wonPrize.code });
    updateLauncher();
    track('spin_wheel_spun', wonPrize.amount);

    var reduce = reduceMotion();
    var target = segmentAngleFor(wonPrize.amount);
    var base = 360 - target;
    // reduced motion still spins, just shorter and gentler (a prize wheel that
    // does not visibly turn reads as broken).
    var turns = reduce ? 2 : 6;
    var dur = reduce ? 1300 : 4200;
    var finalRot = 360 * turns + base;

    if (!disc) { setTimeout(showWin, 50); return; }

    playSpinSound(dur);

    // set the transition inline and force a reflow so it animates from the
    // element's current transform rather than snapping to the end value.
    disc.style.transition = 'transform ' + dur + 'ms cubic-bezier(.16,.67,.13,1)';
    void disc.getBoundingClientRect();
    disc.style.transform = 'rotate(' + (finalRot + 5) + 'deg)';
    setTimeout(function () {
      disc.style.transition = 'transform 420ms ease-out';
      disc.style.transform = 'rotate(' + finalRot + 'deg)';
      setTimeout(showWin, 440);
    }, dur);
  }
  spinButtons.forEach(function (b) { if (b) b.addEventListener('click', function () { unlockAudio(); doSpin(); }); });

  var muteBtn = document.getElementById('g99-mute');
  if (muteBtn) {
    setMuted(muted);
    muteBtn.addEventListener('click', function () {
      setMuted(!muted);
      if (!muted) unlockAudio();
    });
  }

  /* ---------- win + capture ---------- */
  function showWin() {
    spinning = false;
    var off = wonPrize.amount;
    var discounted = CFG.priceCents - off * 100;
    setSlot('prize', money(off * 100) + ' OFF');
    setSlot('prize2', money(off * 100) + ' OFF');
    setSlot('priceline', 'Your personalized song, ' + money(CFG.priceCents) + ' becomes ' + money(discounted));
    titleEl.textContent = 'You won ' + money(off * 100) + ' off';
    sayEl.textContent = '';
    showState('win');
    burstConfetti();
    playWinSound();
    var email = document.getElementById('g99-email');
    if (email) email.focus();
  }

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  function reveal() {
    buildRevealFromState(readState());
    burstConfetti();
  }

  /* copy-code button */
  var copyBtn = document.getElementById('g99-copy');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      if (!readState().claimedAt) return;
      var code = (readState().code || wonPrize && wonPrize.code || '').trim();
      if (!code) return;
      var done = function () {
        track('spin_wheel_code_copied', readState().tier);
        copyBtn.textContent = 'Copied!';
        setTimeout(function () { copyBtn.textContent = 'Copy code'; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () { fallbackCopy(code); done(); });
      } else { fallbackCopy(code); done(); }
    });
  }

  var checkoutLink = document.getElementById('g99-claim-link');
  if (checkoutLink) checkoutLink.addEventListener('click', function (e) {
    if (!readState().claimedAt) { e.preventDefault(); return; }
    track('spin_wheel_checkout_clicked', readState().tier);
  });
  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  /* Keep the email save in the background so the prize reveal remains in the
     popup. This is the original smooth wheel experience. */
  var form = document.getElementById('g99-form');
  var sink = document.getElementById('g99-sink');
  var claimBtn = document.getElementById('g99-claim');
  var pendingClaim = false;
  var claimTimer = null;
  function finishClaim() {
    if (!pendingClaim) return;
    pendingClaim = false;
    if (claimTimer) { clearTimeout(claimTimer); claimTimer = null; }
    writeState({ claimedAt: Date.now() });
    track('spin_wheel_claim_confirmed', readState().tier);
    reveal();
  }

  if (form && sink) {
    sink.addEventListener('load', finishClaim);
    form.addEventListener('submit', function (e) {
      var input = document.getElementById('g99-email');
      var err = document.getElementById('g99-email-err');
      var email = (input.value || '').trim();
      if (!validEmail(email)) { e.preventDefault(); err.textContent = 'Please enter a valid email.'; err.hidden = false; input.focus(); return; }
      err.hidden = true;
      var tags = document.getElementById('g99-tags');
      if (tags) tags.value = 'spinwheel-evergreen,spinwheel-v1,spinwheel-prize-' + wonPrize.amount;
      writeState({ claimAttemptedAt: Date.now() });
      track('spin_wheel_claim_attempted', readState().tier);
      claimBtn.disabled = true;
      claimBtn.textContent = 'Saving...';
      pendingClaim = true;
      /* Some Shopify responses do not trigger a readable iframe callback.
         Never leave a valid shopper stuck waiting for their prize. */
      if (claimTimer) clearTimeout(claimTimer);
      claimTimer = setTimeout(finishClaim, 1200);
      /* No preventDefault: Shopify posts the native customer form in the frame. */
    });
  }

  /* ---------- trigger: 30 seconds or 50% scroll; seven-day cooldown ---------- */
  var COOLDOWN = 7 * 24 * 60 * 60 * 1000;
  function autoSuppressed() {
    var s = readState(), now = Date.now();
    return root.dataset.suppressed === '1' || !!s.spunAt ||
      (s.seenAt && now - s.seenAt < COOLDOWN) ||
      (s.dismissedAt && now - s.dismissedAt < COOLDOWN);
  }
  function maybeAutoOpen(trigger) {
    if (!armed) return;
    armed = false;
    window.removeEventListener('scroll', onAutoScroll);
    if (!root.hidden) return;
    if (autoSuppressed()) return;
    writeState({ seenAt: Date.now() });
    openModal(trigger);
  }
  function onAutoScroll() {
    var distance = document.documentElement.scrollHeight - window.innerHeight;
    if (distance > 0 && window.scrollY / distance >= 0.5) maybeAutoOpen('scroll');
  }
  if (!autoSuppressed()) {
    setTimeout(function () { maybeAutoOpen('delay'); }, 30000);
    window.addEventListener('scroll', onAutoScroll, { passive: true });
  } else {
    armed = false;
  }

  var launcher = document.getElementById('g99-launcher');
  if (launcher) {
    launcher.hidden = root.dataset.productPage === '1';
    updateLauncher();
    launcher.addEventListener('click', function () { openModal('launcher'); });
  }

  window.giftySpin99 = { open: function () { openModal('manual'); }, state: readState };
})();
